import { useLocation } from "react-router-dom";

import {
  DesktopMenuItem,
  UserSvg,
  BriefcaseSvg,
  UserXSvg,
  LogoutSvg,
  UserCheckSvg,
} from "@components/index";

export const LeftSidebarProfile = () => {
  const location = useLocation();

  return (
    <div className="flex min-h-[calc(100dvh_-_152px)] w-[280px] flex-col justify-between border-r border-r-black-16 bg-white-100 px-2 pb-4 pt-10">
      <div className="flex flex-col gap-y-2">
        <DesktopMenuItem
          href="/profile"
          icon={<UserSvg />}
          label="Personal Information"
          isActive={location.pathname === "/profile"}
        />
        <DesktopMenuItem
          href="/profile/my-businesses"
          icon={<BriefcaseSvg />}
          label="My Businesses"
          isActive={location.pathname === "/profile/my-businesses"}
        />
        <DesktopMenuItem
          href="/profile/red-statement"
          icon={<UserCheckSvg />}
          label="RED Statement"
          isActive={location.pathname === "/profile/red-statement"}
        />
        <DesktopMenuItem
          href="/profile/leave"
          icon={<UserXSvg />}
          label="Leave FBTC"
          isActive={location.pathname === "/profile/leave"}
        />
      </div>
      <DesktopMenuItem
        href="/logout"
        icon={<LogoutSvg />}
        label="Logout"
        isActive={location.pathname === "/logout"}
      />
    </div>
  );
};
